let state = {
  requestLog: [],
  loading: false
}
export default state



// WEBPACK FOOTER //
// ./src/store/request/state.js